import { useFormikContext } from "formik";
import { useEffect } from "react";

const getFieldErrorNames = (formikErrors) => {
  const transformObjectToDotNotation = (obj, prefix = "", result = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!value) return;

      const nextKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    });

    return result;
  };

  return transformObjectToDotNotation(formikErrors);
};

function ScrollToFieldError({ scrollBehavior = { behavior: "smooth", block: "start" } }) {
  const { submitCount, isValid, errors } = useFormikContext();

  useEffect(() => {
    if (isValid || !submitCount) return;

    const fieldErrorNames = getFieldErrorNames(errors);

    if (fieldErrorNames.length <= 0) return;

    let element = document.querySelector(`input[name='${fieldErrorNames[0]}']`);

    if (!element) {
      element = document.querySelector(`textarea[name='${fieldErrorNames[0]}']`);
    }

    if (!element) {
      element = document.querySelector(`[id='${fieldErrorNames[0]}']`);
    }

    if (!element) {
      element = document.querySelector(`[class*='${fieldErrorNames[0]}']`);
    }

    if (!element) return;

    // Scroll to first known error into view
    element.scrollIntoView(scrollBehavior);
  }, [submitCount, isValid]);
  return null;
}

export default ScrollToFieldError;
